import * as React from "react";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { ISearchProps } from "../../Resource/Content";
import { AdvancedSearch } from "../Shared/AdvancedSearch";
import { FavouritesToggle } from "../Shared/FavouritesToggle";
import ExcangeTradedSearch from "./ExchangeTradedSearch";
import { UnmountClosed } from "react-collapse";
import { ExchangeTradedResults } from "./ExchangeTradedResults";
import { InvestmentSelectionAction } from "../../Action/InvestmentSelectionAction";
import { ExchangeTradedInstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/ExchangeTradedInstrumentSearchQuery";
import { ProductSort } from "../../../../../Wrap/Constants/Enums/Domain/ProductSort";
import { SortDirection } from "../../../../../Wrap/Core/SortingAndPaging/SortDirection";
import { ResearchISTDispatcher } from "../../../../Dashboard/Components/ToolsAndLiterature/Store/Variable";
import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { useRef } from "react";

export const ExchangeTraded = (props: ISearchProps) => {
    const wrapperRef = useRef(null);
    const [onFavourite, setOnFavourite] = React.useState(false);
    const [favouriteData, setFavouriteData] = React.useState(null);

    const query: InstrumentSearchQuery = {
        ProductTypes: [ProductType.Equity, ProductType.Bond],
        ProductWrapperTypes: [props.type],
        ServiceProposition: props.accountServiceProposition,
    };

    if (props.canBeBought) {
        query["CanBeBought"] = true;
    }
    if (props.canBeSold) {
        query["CanBeSold"] = true;
    }

    if(props.CanBeTransferred) {
        query["CanBeTransferred"] = true;
    }

    const toggleFavourite = (isOn) => {
        if (props.researchIst && wrapperRef && wrapperRef.current) {wrapperRef.current.close();}
        if (!isOn) {
            ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: null });
            return setOnFavourite(isOn);
        }

        return searchFavourite(1);
    };

    const searchFavourite = (pageIndex) => {
        const query: ExchangeTradedInstrumentSearchQuery = {
            CurrentPage: pageIndex,
        };
        if (props.canBeBought) {
            query["CanBeBought"] = true;
        }
        if (props.canBeSold) {
            query["CanBeSold"] = true;
        }
        if(props.CanBeTransferred) {
            query["CanBeTransferred"] = true;
        }
        query["IncludeFavouritesOnly"] = true;
        query["ProductWrapperTypes"] = [props.type];
        query["Sorting"] = [{ Field: ProductSort.Name, Direction: SortDirection.Ascending }];
        query["ProductWrapperTypes"] = [props.type];
        query["ServiceProposition"] = props.accountServiceProposition;
        InvestmentSelectionAction.searchExchangedTrade(query, props.hiercharyId, (data) => {
            ResearchISTDispatcher.dispatch({ actionType: ActionType.Success, payload: data.Results });
            setOnFavourite(true);
            setFavouriteData(data);
        });
    };

    return (
        <div>
            <div className="row row-right mb-10">
                {/* 
 This button will be implemented in TS2.1
                <div className="col-auto">
                    <button className="upload-button">
                        <span className="text">Upload xls</span>
                        <span className="icon" aria-hidden={true}></span>
                    </button>
                </div>
                */}
                <div className="col-auto">
                    <FavouritesToggle
                        label="Favourites"
                        isFavourite={onFavourite}
                        onToggle={() => toggleFavourite(!onFavourite)}
                    />
                </div>
            </div>
            {!props.researchIst && (
                <UnmountClosed isOpened={onFavourite}>
                    {favouriteData && (
                        <ExchangeTradedResults
                            data={favouriteData}
                            allocationTable={props.tableData}
                            onPageChange={(i) => searchFavourite(i)}
                            isFavourite
                            researchIst={false}
                        />
                    )}
                </UnmountClosed>
            )}
            <AdvancedSearch
                query={query}
                hiercharyId={props.hiercharyId}
                index={props.index}
                cssWrapper="mb-24"
                showResult={wrapperRef}
            >
                <ExcangeTradedSearch
                    ref={wrapperRef}
                    hiercharyId={props.hiercharyId}
                    tableData={props.tableData}
                    type={props.type}
                    index={props.index}
                    researchIst={props.researchIst}
                    accountServiceProposition={props.accountServiceProposition}
                    canBeBought={props.canBeBought}
                    canBeSold={props.canBeSold}
                    canBeTransferred={props.CanBeTransferred}
                />
            </AdvancedSearch>
        </div>
    );
};
